import {useUserStore} from "../../zustand/useStore";
import { logOut } from "@supabase/queries";
export default function useSignOut() {
    const userData = useUserStore.getState();

    const logoutHandler = async () => {
        await logOut();
        userData.logout();
    };
    return logoutHandler;
}